import { render } from "./LichensDataMaterial.vue?vue&type=template&id=48956266"
import script from "./LichensDataMaterial.vue?vue&type=script&lang=js"
export * from "./LichensDataMaterial.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__